import nullthrows from "../lib/nullthrows";

class Rect {
  constructor(rect, domain) {
    this.bottom = void 0;
    this.domain = void 0;
    this.height = void 0;
    this.left = void 0;
    this.right = void 0;
    this.top = void 0;
    this.width = void 0;
    this.top = rect.top;
    this.right = rect.right;
    this.bottom = rect.bottom;
    this.left = rect.left;
    this.width = rect.width;
    this.height = rect.height;
    this.domain = domain;
  }

  static fromClientRect(rect, domain) {
    const {
      top,
      right,
      bottom,
      left,
      width,
      height
    } = rect;

    if (domain === 'viewport') {
      return new Rect({
        top,
        right,
        bottom,
        left,
        width,
        height
      }, 'viewport');
    }

    const documentElement = nullthrows(document.documentElement);
    const body = nullthrows(document.body);
    const leftAdjust = window.pageXOffset || documentElement.scrollLeft || body.scrollLeft;
    const topAdjust = window.pageYOffset || documentElement.scrollTop || body.scrollTop;
    return new Rect({
      top: top + topAdjust,
      left: left + leftAdjust,
      bottom,
      right,
      width,
      height
    }, 'document');
  }

}

export default Rect;